( function( $, window, document, undefined ) {

	let $drips = $('.js-drip-animation');

	// once all images are loaded
	$drips.imagesLoaded(function() {
		$drips.find('.drip').addClass('animate');
	});

} )( jQuery, window, document );
